.resultIngredient {
  padding: 0px 4px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  display: inline-block;
  font-size: 12px;
  margin-left: 8px;
}
.resultIngredient .icon {
  display: inline;
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  top: 0px;
}
.resultIngredient .amount {
  display: inline;
  color: rgba(255, 255, 255, 0.7);
  font-weight: bold;
}

.ingredientSelected {
  border-color: #30c030;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1eWFibGVTZWFyY2hSZXN1bHQuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUNGO0VBQ0U7RUFDQTtFQUNBOzs7QUFFSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnJlc3VsdEluZ3JlZGllbnRcbiAgcGFkZGluZzogMHB4IDRweFxuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNClcbiAgYm9yZGVyLXJhZGl1czogNHB4XG4gIGRpc3BsYXk6IGlubGluZS1ibG9ja1xuICBmb250LXNpemU6IDEycHhcbiAgbWFyZ2luLWxlZnQ6IDhweFxuICAuaWNvblxuICAgIGRpc3BsYXk6IGlubGluZVxuICAgIGNvbG9yOiByZ2JhKDAsIDAsIDAsIDAuNSlcbiAgICBmb250LXNpemU6IDE0cHhcbiAgICB0b3A6IDBweFxuICAuYW1vdW50XG4gICAgZGlzcGxheTogaW5saW5lXG4gICAgY29sb3I6IHJnYmEoMjU1LCAyNTUsIDI1NSwgMC43KVxuICAgIGZvbnQtd2VpZ2h0OiBib2xkXG5cbi5pbmdyZWRpZW50U2VsZWN0ZWRcbiAgYm9yZGVyLWNvbG9yOiAjMzBjMDMwXG5cbiJdfQ== */